import { actionTypes as resourceActions } from 'redux-resource';
import * as types from './types';

const createDefaults = {
  resourceType: 'orderSim',
  requestKey: 'create'
}

export const create = (payload) => ({
  type: types.CREATE,
  payload,
});

export const createPending = () => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_PENDING
});

export const createSucceeded = (response) => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_SUCCEEDED,
  resources: [response.data]
});

export const createFailed = () => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_FAILED
});

export const fetchProducts = ids => ({
  type: types.FETCH_PRODUCTS,
  payload: { ids },
})
